// assets/merch-upsell.js
(function () {
  class MerchUpsell {
    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('[data-merch-upsell-btn]');
      this.hint = container.querySelector('[data-merch-upsell-hint]');
      this.bindEvents();
      this.refreshState();
    }

    bindEvents() {
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => this.handleAdd(e));
      });

      // Re-check à chaque mutation du panier (add / update / remove),
      // que ce soit via le drawer ou la page /cart de Dawn.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshState());
      }
    }

    async checkPhonoInCart() {
      const res = await fetch('/?sections=cart-phono-status');
      const data = await res.json();
      return /window\.cartHasPhono\s*=\s*true/.test(data['cart-phono-status'] || '');
    }

    async refreshState() {
      const hasPhono = await this.checkPhonoInCart();
      this.toggleButtons(hasPhono);
      // Le nettoyage des produits BONUS orphelins est géré globalement
      // dans theme.liquid (actif sur toutes les pages, pas seulement ici).
    }

    toggleButtons(enabled) {
      this.buttons.forEach((btn) => {
        btn.disabled = !enabled;
      });
      if (this.hint) {
        this.hint.classList.toggle('is-visible', !enabled);
      }
      this.container.classList.toggle('is-unlocked', enabled);
    }

    // Anime une copie de l'image produit qui "vole" depuis la carte jusqu'à
    // l'icône panier du header. Fonctionne avec un header en position: fixed
    // car getBoundingClientRect() renvoie déjà des coordonnées viewport,
    // exactement ce dont position: fixed a besoin (aucune compensation de scroll requise).
    flyToCart(imageEl) {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (!cartIcon || !imageEl) return;

      const startRect = imageEl.getBoundingClientRect();
      const endRect = cartIcon.getBoundingClientRect();

      const flyer = document.createElement('img');
      flyer.src = imageEl.currentSrc || imageEl.src;
      flyer.style.position = 'fixed';
      flyer.style.top = `${startRect.top}px`;
      flyer.style.left = `${startRect.left}px`;
      flyer.style.width = `${startRect.width}px`;
      flyer.style.height = `${startRect.height}px`;
      flyer.style.borderRadius = '50%';
      flyer.style.objectFit = 'cover';
      flyer.style.zIndex = '9999';
      flyer.style.pointerEvents = 'none';
      flyer.style.transition = 'transform 0.7s cubic-bezier(0.55, 0, 1, 0.45), opacity 0.7s ease';
      flyer.style.willChange = 'transform, opacity';
      document.body.appendChild(flyer);

      // Force le navigateur à enregistrer la position de départ avant d'animer
      flyer.getBoundingClientRect();

      const deltaX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
      const deltaY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);

      requestAnimationFrame(() => {
        flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.15)`;
        flyer.style.opacity = '0.3';
      });

      flyer.addEventListener(
        'transitionend',
        () => {
          flyer.remove();
          cartIcon.style.transition = 'transform 0.25s ease';
          cartIcon.style.transform = 'scale(1.25)';
          setTimeout(() => {
            cartIcon.style.transform = 'scale(1)';
          }, 220);
        },
        { once: true }
      );
    }

    async handleAdd(e) {
      const btn = e.currentTarget;
      if (btn.disabled) return;

      // double-check juste avant l'ajout (anti race condition)
      const hasPhono = await this.checkPhonoInCart();
      if (!hasPhono) {
        this.toggleButtons(false);
        return;
      }

      const variantId = btn.dataset.merchVariantId;
      const label = btn.querySelector('[data-btn-label]');
      const originalText = label.textContent;
      const card = btn.closest('.merch-upsell__card');
      const productImage = card ? card.querySelector('.merch-upsell__media img') : null;

      btn.disabled = true;
      label.textContent = 'Ajout...';

      try {
        const res = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1,
            }],
          }),
        });

        if (!res.ok) throw new Error('cart add failed');

        if (productImage) {
          this.flyToCart(productImage);
        }

        label.textContent = 'Ajouté ✓';

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'merch-upsell' });
        }

        setTimeout(() => {
          label.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('[merch-upsell]', err);
        label.textContent = originalText;
        btn.disabled = false;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-merch-upsell]').forEach((el) => new MerchUpsell(el));
  });
})();